export enum ProgressIndicatorColorType {
  ACCENT = 'accent',
  PRIMARY = 'primary',
  WARN = 'warn'
}
